import { StyleSheet } from "react-native"
import { baseColors, baseFontFamily, basePadding } from "@Constants/baseStyles"
import { RFValue } from "react-native-responsive-fontsize"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: baseColors.white,
        paddingTop: basePadding.paddingVertical
    },
    content: {
        paddingVertical: basePadding.paddingVertical
    },
    header: {
        paddingHorizontal: RFValue(4),
        paddingBottom: RFValue(4)
    },
    topicContainer: {
        marginBottom: RFValue(10)
    },
    topicLabel: {
        paddingHorizontal: 25,
        paddingVertical: 10,
        borderRadius: 10,
        marginRight: 12,
        backgroundColor: baseColors.green.light,
        marginBottom: RFValue(18)
    },
    topic: {
        flexDirection: "row",
        flexWrap: "wrap",
        marginTop: RFValue(18)
    },

    clearFilter: {
        marginTop: 18,
        alignItems: "center"
    },
    clearFilterLabel: { color: baseColors.green.primary, textDecorationLine: "underline" },
    radioGroupContainer: { flexDirection: "row", marginVertical: RFValue(20) },
    radioContainer: {
        marginRight: RFValue(50)
    },
    radioContent: { flexDirection: "row", alignItems: "center" },
    loading: {
        flex: 1,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
    },
    createForumTitle: {
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row"
    },
    formContainer: {
        marginTop: 20
    }
})

export default styles
